
<template>
  <div class="home">
    <bannera :bannerImg="bannerImg" :bannerImg1="bannerImg1" :wenziImg="wenziImg"  :wenziImg1="wenziImg1"   />
    <contenta/>
<footera/>
  </div>
</template>

<script>
import "../../assets/js/pcRem";
import '../../assets/styles/common.css'
import '../../assets/js/base64'

import bannera from '../components/banner.vue'
import contenta from '../components/content.vue'
import footera from '../components/footer.vue'
export default {
  name: 'App',
  components: {

    bannera,
    contenta,
footera
  },
  data(){
    return {
      headerImg:require("../../assets/img/return.png"),
      bannerImg:require("../../assets/img/pc/banner.png"),
      bannerImg1:require("../../assets/img/pc/banner1.png"),
      wenziImg:require("../../assets/img/pc/text.png"),
      wenziImg1:require("../../assets/img/pc/text1.png"),
    }
  },
  methods:{
    getUrl(){
      
    }
  },
  mounted () {
    
  }
}
</script>

<style lang="scss" scoped>

</style>

